module.exports = __webpack_public_path__ + "img/0bca332.png";